import { INDICATOR_IMAGES } from 'app/KinerjaPage/pages/PelaksanaanV2/constants/indicator'

export function getIndicatorIllustrationPath(name: string): string {
  return (
    INDICATOR_IMAGES[name.toLowerCase()] ||
    '/illustrations/img-chalk-board-teach-character-stundet.png'
  )
}
